// Mock data for HITECH GROUP website - Bilingual content

export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      aiConcierge: 'AI Concierge',
      approach: 'Approach',
      contact: 'Contact',
      contactUs: 'Contact Us'
    },
    hero: {
      headline: 'Intelligent IT Consulting',
      headlineLine2: '& Technology Solutions',
      subheadline: 'Structured. Secure. Enterprise-Grade.',
      description: 'HITECH GROUP is a French IT consulting and technology company and a wholly owned subsidiary of Global Services s.r.o., delivering structured, secure and enterprise-grade digital solutions.',
      cta1: 'Explore Our Services',
      cta2: 'Contact Us'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Enterprise-grade solutions tailored to your needs',
      items: [
        {
          id: 'consulting',
          title: 'IT Consulting & Architecture',
          shortDesc: 'Strategic guidance for complex IT environments.',
          fullDesc: 'Strategic guidance for complex IT environments.',
          features: [
            'Enterprise IT consulting and advisory',
            'Digital transformation roadmaps',
            'System and solution architecture',
            'Technology stack assessment',
            'Long-term IT strategy development'
          ]
        },
        {
          id: 'cloud',
          title: 'Cloud & Infrastructure',
          shortDesc: 'Secure, scalable infrastructure for modern enterprises.',
          fullDesc: 'Secure, scalable infrastructure for modern enterprises.',
          features: [
            'Cloud environment design and migration',
            'Virtual workspace solutions',
            'Private and hybrid cloud architecture',
            'Infrastructure optimization',
            'Disaster recovery planning'
          ]
        },
        {
          id: 'data',
          title: 'Data & AI Solutions',
          shortDesc: 'Intelligent systems for data-driven decisions.',
          fullDesc: 'Intelligent systems for data-driven decisions.',
          features: [
            'Data platform architecture',
            'Business intelligence solutions',
            'Process automation',
            'AI and machine learning integration',
            'Predictive analytics systems'
          ]
        },
        {
          id: 'software',
          title: 'Custom Software & Platforms',
          shortDesc: 'Tailored solutions for unique business requirements.',
          fullDesc: 'Tailored solutions for unique business requirements.',
          features: [
            'Enterprise application development',
            'Internal platform creation',
            'CRM and ERP customization',
            'API development and integration',
            'Legacy system modernization'
          ]
        }
      ]
    },
    trust: {
      title: 'Why Choose HITECH GROUP',
      items: [
        {
          title: 'Enterprise Security Standards',
          description: 'Security-first approach in every solution we deliver.'
        },
        {
          title: 'International Group Expertise',
          description: 'Backed by Global Services s.r.o. international capabilities.'
        },
        {
          title: 'Long-term Partnership Focus',
          description: 'Building relationships that drive sustained success.'
        }
      ]
    },
    cta: {
      title: 'Ready to transform your IT infrastructure?',
      button: 'Start a Conversation'
    },
    about: {
      title: 'About Us',
      whoWeAre: {
        title: 'Who We Are',
        content: `HITECH GROUP is a French IT consulting and technology company and a wholly owned subsidiary of Global Services s.r.o., an international technology group.

As part of a larger group structure, we combine local French expertise with international technological capabilities to deliver enterprise-grade solutions designed for long-term performance, compliance, and scalability.

Our team brings together consultants, architects, and engineers who share a commitment to structured thinking, technical excellence, and client success.`
      },
      values: {
        title: 'Our Values',
        items: [
          {
            title: 'Precision',
            description: 'Structured methodology in every engagement'
          },
          {
            title: 'Security',
            description: 'Enterprise-grade protection as a foundation'
          },
          {
            title: 'Partnership',
            description: 'Long-term relationships over transactions'
          }
        ]
      }
    },
    approach: {
      title: 'Our Approach',
      intro: 'We believe effective IT consulting requires more than technical expertise — it demands structured thinking, methodical execution, and unwavering commitment to security and compliance. Our approach is built on enterprise standards and designed for long-term success.',
      methodology: [
        {
          step: '01',
          title: 'Discover',
          description: 'Understanding your environment and objectives'
        },
        {
          step: '02',
          title: 'Design',
          description: 'Architecting solutions aligned with enterprise standards'
        },
        {
          step: '03',
          title: 'Deliver',
          description: 'Implementing with precision and documentation'
        },
        {
          step: '04',
          title: 'Support',
          description: 'Ensuring long-term performance and evolution'
        }
      ],
      principles: {
        title: 'Key Principles',
        items: [
          'Security-first mindset in every decision',
          'Compliance with European and international standards',
          'Scalable architecture for future growth',
          'Knowledge transfer and documentation',
          'Transparent communication throughout'
        ]
      }
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Let\'s discuss how we can support your IT objectives.',
      form: {
        name: 'Full Name',
        company: 'Company Name',
        email: 'Email Address',
        phone: 'Phone (optional)',
        subject: 'Subject',
        subjectOptions: [
          { value: 'general', label: 'General Inquiry' },
          { value: 'project', label: 'Project Discussion' },
          { value: 'partnership', label: 'Partnership' },
          { value: 'other', label: 'Other' }
        ],
        message: 'Message',
        submit: 'Send Message',
        sending: 'Sending...',
        successTitle: 'Message Sent!',
        successMessage: 'We\'ll get back to you within 24 hours.',
        errorMessage: 'Failed to send message. Please try again later or contact us directly.',
        sending: 'Sending...',
        successTitle: 'Message Sent!',
        successMessage: 'We\'ll get back to you within 24 hours.',
        errorMessage: 'Failed to send message. Please try again later or contact us directly.'
      },
      info: {
        title: 'Contact Information',
        address: '2323 Chemin de Saint-Bernard, 06220 Vallauris, France',
        email: 'contact@hitech-group.io',
        hours: 'Monday – Friday: 9:00 – 18:00 (CET)'
      }
    },
    footer: {
      description: 'French IT consulting and technology company delivering enterprise-grade solutions.',
      quickLinks: 'Quick Links',
      contactInfo: 'Contact Information',
      legal: 'Legal',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      legalNotice: 'Legal Notice',
      corporateStatement: 'HITECH GROUP is a wholly owned subsidiary of Global Services s.r.o., an international technology group.',
      copyright: '© 2025 HITECH GROUP. All rights reserved.'
    },
    legal: {
      privacyPolicy: {
        title: 'Privacy Policy',
        lastUpdated: 'Last Updated: January 2025',
        contactTitle: 'Contact Us',
        contactText: 'If you have any questions about this Privacy Policy, please contact us:',
        sections: [
          {
            title: '1. Introduction',
            content: [
              'HITECH GROUP ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.',
              'HITECH GROUP is a French IT consulting and technology company and a wholly owned subsidiary of Global Services s.r.o., an international technology group. By using our website, you consent to the data practices described in this policy.'
            ]
          },
          {
            title: '2. Information We Collect',
            content: [
              'We may collect information that you provide directly to us, including:',
              'We also automatically collect certain information when you visit our website, such as your IP address, browser type, device information, and usage patterns through cookies and similar tracking technologies.'
            ],
            list: [
              'Personal identification information (name, email address, phone number)',
              'Company information (company name, job title)',
              'Communication data (messages sent through our contact forms)',
              'Technical data (IP address, browser type, device information)',
              'Usage data (pages visited, time spent on pages, click patterns)'
            ]
          },
          {
            title: '3. How We Use Your Information',
            content: [
              'We use the information we collect to:',
              'We process your personal data based on legitimate business interests, contractual necessity, compliance with legal obligations, or your consent.'
            ],
            list: [
              'Provide, maintain, and improve our services',
              'Respond to your inquiries and provide customer support',
              'Send you technical updates, newsletters, and marketing communications (with your consent)',
              'Analyze website usage and trends to enhance user experience',
              'Comply with legal obligations and protect our legal rights',
              'Prevent fraud and ensure security'
            ]
          },
          {
            title: '4. Data Sharing and Disclosure',
            content: [
              'We do not sell your personal information. We may share your information with:',
              'We require all third parties to respect the security of your personal data and to treat it in accordance with applicable data protection laws.'
            ],
            list: [
              'Our parent company, Global Services s.r.o., for business operations and support',
              'Service providers who assist us in operating our website and conducting our business (hosting, analytics, email services)',
              'Legal authorities when required by law or to protect our rights',
              'Business partners in connection with services we provide to you (with your consent)'
            ]
          },
          {
            title: '5. Data Security',
            content: [
              'We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure.',
              'We use industry-standard security protocols, encryption where appropriate, and regular security assessments to safeguard your information.'
            ]
          },
          {
            title: '6. Your Rights',
            content: [
              'Under applicable data protection laws (including GDPR), you have the right to:',
              'To exercise these rights, please contact us using the contact information provided below.'
            ],
            list: [
              'Access your personal data',
              'Rectify inaccurate or incomplete data',
              'Request deletion of your personal data',
              'Object to processing of your personal data',
              'Request restriction of processing',
              'Data portability',
              'Withdraw consent at any time',
              'Lodge a complaint with a supervisory authority'
            ]
          },
          {
            title: '7. Cookies and Tracking Technologies',
            content: [
              'We use cookies and similar tracking technologies to track activity on our website and store certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.',
              'Types of cookies we use:',
              'You can manage your cookie preferences through your browser settings.'
            ],
            list: [
              'Essential cookies: Required for the website to function properly',
              'Analytics cookies: Help us understand how visitors interact with our website',
              'Functional cookies: Remember your preferences and settings',
              'Marketing cookies: Used to deliver relevant advertisements (with your consent)'
            ]
          },
          {
            title: '8. Data Retention',
            content: [
              'We retain your personal data only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.',
              'When we no longer need your personal data, we will securely delete or anonymize it.'
            ]
          },
          {
            title: '9. International Data Transfers',
            content: [
              'As HITECH GROUP is a wholly owned subsidiary of Global Services s.r.o. (Czech Republic), your data may be transferred to and processed in countries outside the European Economic Area (EEA).',
              'We ensure that appropriate safeguards are in place to protect your personal data in accordance with applicable data protection laws, including standard contractual clauses approved by the European Commission.'
            ]
          },
          {
            title: '10. Changes to This Privacy Policy',
            content: [
              'We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.',
              'You are advised to review this Privacy Policy periodically for any changes.'
            ]
          }
        ]
      },
      termsOfService: {
        title: 'Terms of Service',
        lastUpdated: 'Last Updated: January 2025',
        contactTitle: 'Contact Us',
        contactText: 'If you have any questions about these Terms of Service, please contact us:',
        sections: [
          {
            title: '1. Acceptance of Terms',
            content: [
              'By accessing and using the HITECH GROUP website and services, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our website or services.',
              'HITECH GROUP is a French IT consulting and technology company and a wholly owned subsidiary of Global Services s.r.o., an international technology group.'
            ]
          },
          {
            title: '2. Description of Services',
            content: [
              'HITECH GROUP provides IT consulting, technology solutions, and related services including but not limited to:',
              'All services are provided subject to separate service agreements and statements of work that will govern the specific terms, deliverables, and pricing for each engagement.'
            ],
            list: [
              'IT consulting and architecture services',
              'Cloud infrastructure design and implementation',
              'Data analytics and AI solutions',
              'Custom software development',
              'Digital transformation consulting',
              'Technology advisory services'
            ]
          },
          {
            title: '3. Use of Website',
            content: [
              'You agree to use our website only for lawful purposes and in accordance with these Terms of Service. You agree not to:',
              'We reserve the right to terminate or suspend access to our website immediately, without prior notice, for conduct that we believe violates these Terms of Service or is harmful to other users, us, or third parties.'
            ],
            list: [
              'Violate any applicable laws or regulations',
              'Infringe upon the rights of others',
              'Transmit any harmful, offensive, or illegal content',
              'Attempt to gain unauthorized access to our systems',
              'Interfere with or disrupt the website or servers',
              'Use automated systems to access the website without permission',
              'Reproduce, duplicate, or copy any content without authorization'
            ]
          },
          {
            title: '4. Intellectual Property',
            content: [
              'All content on this website, including text, graphics, logos, images, software, and other materials, is the property of HITECH GROUP or its licensors and is protected by French and international copyright, trademark, and other intellectual property laws.',
              'You may not reproduce, distribute, modify, create derivative works of, publicly display, or otherwise use any content from this website without our prior written consent.'
            ]
          },
          {
            title: '5. Confidentiality and Non-Disclosure',
            content: [
              'In the course of providing services, HITECH GROUP may have access to confidential information belonging to clients. We maintain strict confidentiality standards and comply with all applicable data protection regulations.',
              'Clients may also receive confidential information about HITECH GROUP\'s methodologies, processes, and proprietary technologies, which must be kept confidential.'
            ]
          },
          {
            title: '6. Limitation of Liability',
            content: [
              'To the maximum extent permitted by law, HITECH GROUP and its parent company Global Services s.r.o. shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses.',
              'Our total liability for any claims arising from or related to your use of our website or services shall not exceed the amount you paid to us in the twelve (12) months preceding the claim.'
            ]
          },
          {
            title: '7. Disclaimer of Warranties',
            content: [
              'The information on this website is provided "as is" without warranties of any kind, either express or implied. We do not warrant that the website will be uninterrupted, error-free, or free of viruses or other harmful components.',
              'We make no representations or warranties regarding the accuracy, completeness, or suitability of the information for any particular purpose.'
            ]
          },
          {
            title: '8. Indemnification',
            content: [
              'You agree to indemnify, defend, and hold harmless HITECH GROUP, Global Services s.r.o., and their respective officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses arising out of or relating to your use of our website or services, violation of these Terms of Service, or infringement of any rights of another.'
            ]
          },
          {
            title: '9. Governing Law and Jurisdiction',
            content: [
              'These Terms of Service shall be governed by and construed in accordance with the laws of France, without regard to its conflict of law provisions.',
              'Any disputes arising out of or relating to these Terms of Service or our services shall be subject to the exclusive jurisdiction of the courts of France.'
            ]
          },
          {
            title: '10. Changes to Terms',
            content: [
              'We reserve the right to modify these Terms of Service at any time. We will notify users of any material changes by posting the updated terms on this page and updating the "Last Updated" date.',
              'Your continued use of our website or services after such modifications constitutes acceptance of the updated terms.'
            ]
          },
          {
            title: '11. Severability',
            content: [
              'If any provision of these Terms of Service is found to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary so that these Terms of Service shall otherwise remain in full force and effect.'
            ]
          },
          {
            title: '12. Contact Information',
            content: [
              'For questions regarding these Terms of Service, please contact us using the information provided in the Contact section of this website.'
            ]
          }
        ]
      },
      legalNotice: {
        title: 'Legal Notice',
        lastUpdated: 'Last Updated: January 2025',
        companyInfoTitle: 'Company Information',
        subsidiaryNote: 'HITECH GROUP is a wholly owned subsidiary of Global Services s.r.o.',
        sections: [
          {
            title: '1. Company Information',
            content: [
              'This website is operated by HITECH GROUP, a French IT consulting and technology company.',
              'HITECH GROUP is a wholly owned subsidiary of Global Services s.r.o., an international technology group based in the Czech Republic.'
            ]
          },
          {
            title: '2. Publication Director',
            content: [
              'The publication director of this website is the legal representative of HITECH GROUP.'
            ]
          },
          {
            title: '3. Hosting',
            content: [
              'This website is hosted by service providers selected by HITECH GROUP. For information regarding hosting, please contact us using the contact information provided below.'
            ]
          },
          {
            title: '4. Intellectual Property',
            content: [
              'All content on this website, including but not limited to text, graphics, logos, images, audio clips, digital downloads, and software, is the property of HITECH GROUP or its content suppliers and is protected by French and international copyright and trademark laws.',
              'Any reproduction, representation, modification, publication, or adaptation of all or part of the elements of the site, regardless of the means or process used, is prohibited without prior written authorization from HITECH GROUP.'
            ]
          },
          {
            title: '5. Limitation of Liability',
            content: [
              'HITECH GROUP strives to provide accurate and up-to-date information on this website. However, we cannot guarantee the accuracy, completeness, or timeliness of all information.',
              'HITECH GROUP shall not be liable for any direct or indirect damage resulting from the use of this website or the inability to use it, including but not limited to loss of data, loss of profits, or business interruption.',
              'The information on this website is provided for general informational purposes only and does not constitute professional advice. For specific advice regarding your situation, please consult with our team directly.'
            ]
          },
          {
            title: '6. External Links',
            content: [
              'This website may contain links to external websites. HITECH GROUP is not responsible for the content, privacy practices, or security of external websites.',
              'The inclusion of any link does not imply endorsement by HITECH GROUP of the linked website or its content.'
            ]
          },
          {
            title: '7. Applicable Law',
            content: [
              'This Legal Notice is governed by French law. Any disputes arising from the use of this website shall be subject to the exclusive jurisdiction of the French courts.'
            ]
          },
          {
            title: '8. Data Protection',
            content: [
              'HITECH GROUP is committed to protecting your personal data in accordance with applicable data protection laws, including the General Data Protection Regulation (GDPR).',
              'For detailed information about how we collect, use, and protect your personal data, please refer to our Privacy Policy.'
            ]
          },
          {
            title: '9. Cookies',
            content: [
              'This website uses cookies to enhance user experience and analyze website traffic. By continuing to use this website, you consent to our use of cookies.',
              'For more information about our use of cookies, please refer to our Privacy Policy.'
            ]
          }
        ]
      }
    },
    aiConcierge: {
      meta: { title: 'AI Concierge Service | HITECH GROUP', description: 'AI-powered concierge platform for hotels. Integrates with PMS, CRM, IoT. 30+ languages. 24/7 personalized guest service.' },
      hero: {
        badge: 'AI-Powered Hospitality',
        headline: 'AI Concierge Service',
        subheadline: 'Your Smartest Team Member Never Sleeps',
        description: 'An AI-powered concierge platform that integrates into your hotel\'s ecosystem, understands your guests, and delivers personalized service at every touchpoint — around the clock, in any language, without adding headcount.',
        ctaDemo: 'Request a Demo →',
        ctaLearn: 'Learn More',
        stats: [
          { label: 'Availability', value: '24/7' },
          { label: 'Languages', value: '30+' },
          { label: 'Response Time', value: '<3s' },
          { label: 'Query Resolution', value: '85%' }
        ]
      },
      problem: {
        title: 'The Reality of Hotel Operations Today',
        subtitle: 'Every hotel manager knows these situations. They happen daily.',
        items: [
          { problemTitle: 'The 2 AM Problem', problem: 'It\'s 2:17 AM. A Japanese couple arrives after a delayed flight. They don\'t speak English or French. The night receptionist is alone, handling a noise complaint. The couple needs directions, wants food, and their room is too cold. They wait 12 minutes before anyone helps. By morning, there\'s a negative review.', solution: 'The guest opens the hotel app. The AI detects their language and greets them in Japanese. It guides them to their room with a visual map, orders a late-night meal, and adjusts the room temperature — all before they reach their door. The receptionist never needed to leave the noise complaint.' },
          { problemTitle: 'The Repetition Trap', problem: 'Your front desk answers the same 15–20 questions hundreds of times per week: Wi-Fi password, breakfast time, gym location, late checkout, airport directions. Each answer takes 1–3 minutes. Your most skilled hospitality professionals spend the majority of their shift as an FAQ terminal instead of creating memorable experiences.', solution: 'AI Concierge handles every repetitive question instantly with contextual responses. When a guest asks about breakfast at 10:45, it doesn\'t just say "7–11 AM" — it says: "Breakfast is still being served for 15 more minutes. I can also reserve a table for lunch at 13:00." Your staff is freed to focus on genuine hospitality.' },
          { problemTitle: 'The Language Barrier', problem: 'A German family asks about children\'s activities. The receptionist tries to explain in basic English, but nuance is lost. They miss the perfect boat tour. A Brazilian couple wants a specific spa treatment but can\'t communicate the details. They give up and go to a competitor. Every miscommunication is a missed connection — and missed revenue.', solution: 'AI Concierge communicates natively in 30+ languages — not just translating words, but understanding cultural context. It recommends the boat tour to the German family because it knows they have children. It explains every spa option to the Brazilian couple in fluent Portuguese and books the exact treatment. No miscommunication. No lost guests.' },
          { problemTitle: 'Invisible Revenue', problem: 'Your hotel has a beautiful spa, an excellent restaurant, and partnerships with tour operators. But most guests never hear about them — or hear too late. "I didn\'t know you had a rooftop bar!" Staff is too busy for proactive suggestions. Brochures sit unread. The in-room TV menu is ignored.', solution: 'AI Concierge proactively suggests relevant services based on context and timing. On a rainy afternoon, it recommends the spa. Before dinner, it highlights tonight\'s special menu. When a guest mentions an anniversary, it offers a room upgrade or champagne package. The AI doesn\'t wait to be asked — it helps guests discover everything your hotel offers.' },
          { problemTitle: 'Feedback Too Late', problem: 'A guest had a bad experience with room cleanliness on day one. They said nothing. Endured it for three days. Declined the checkout survey. Two days later, a one-star review on TripAdvisor. You never had a chance to fix it. The problem wasn\'t just cleanliness — it was that the guest had no easy way to report it.', solution: 'AI Concierge creates a low-friction channel for real-time feedback. It checks in proactively: "How is your stay so far?" When the guest mentions the issue, the AI creates a housekeeping ticket, sends a team, and follows up within the hour. The one-star review never gets written. Instead, the guest leaves impressed.' },
          { problemTitle: 'The Inconsistency Problem', problem: 'Your best concierge, Maria, knows every guest\'s name, remembers preferences, makes every interaction personal. But Maria works Monday to Friday, 8 AM to 4 PM. Weekends, holidays, nights — service quality drops. New staff don\'t know regulars. Seasonal hires haven\'t learned local recommendations. Quality depends on who\'s on shift.', solution: 'AI Concierge delivers Maria-level personalization 24/7/365. It remembers every guest, every preference, every past interaction — forever. When Mr. Chen returns for the third time, the AI greets him by name, offers his preferred room on a high floor, and suggests the restaurant he loved last visit. Consistency stops depending on individual staff.' }
        ]
      },
      beforeAfter: {
        title: 'Before vs. After: A Day in Your Hotel',
        rows: [
          { situation: 'Guest arrives at 2 AM', without: 'Waits for the only night receptionist. Communication limited to basic English.', with: 'Instant greeting in native language via phone. Room guide, food, temperature — handled before reaching the room.' },
          { situation: '100 guests ask about Wi-Fi', without: 'Staff answers the same question 100 times. ~3 hours of staff time per day.', with: 'AI answers instantly every time. Staff freed for meaningful interactions.' },
          { situation: 'Guest has a complaint', without: 'Guest hesitates to go to front desk. Frustration builds. Negative review after checkout.', with: 'Guest mentions issue via app. Ticket created and resolved within 30 min. Guest feels heard.' },
          { situation: 'Dinner recommendation', without: 'Depends on which staff is asked. New employee gives generic answer.', with: 'AI recommends based on preferences, dietary needs, group size, real-time availability. Books instantly.' },
          { situation: 'Returning VIP', without: 'New receptionist doesn\'t recognize them. Guest repeats all preferences.', with: 'AI greets by name, recalls preferences, proactively offers favorite room and restaurant.' },
          { situation: 'Hotel has a great spa', without: 'Brochure in room unread. Guest checks out unaware spa existed.', with: 'AI suggests spa on a rainy afternoon when guest has no plans. Books in 30 seconds.' },
          { situation: 'Peak season', without: 'Staff overwhelmed. Response times increase. Service quality drops.', with: 'AI handles unlimited concurrent conversations. Staff focuses on complex situations.' }
        ]
      },
      howItWorks: {
        title: 'How AI Concierge Works',
        subtitle: 'Not a chatbot. An intelligent hospitality platform that understands, acts, and learns.',
        cards: [
          { title: 'Context-Aware AI', description: 'Understands intent, not just keywords. Handles complex multi-step requests, remembers conversation history. When a guest asks for "something for the kids," it knows the children\'s ages from the booking.' },
          { title: 'Deep Integration', description: 'Connected to PMS, CRM, restaurant/spa booking, IoT room controls. The AI doesn\'t just answer — it books tables, adjusts thermostats, creates maintenance tickets, processes check-ins.' },
          { title: 'True Multilingual', description: 'Native-quality conversation in 30+ languages with cultural awareness. Not machine translation — the AI understands nuances, local expressions, and appropriate formality levels.' },
          { title: 'Voice & Text', description: 'In-room voice assistant for hands-free interaction, plus text channels via app and website widget. Guests choose how they communicate. Context follows across channels.' },
          { title: 'Proactive Service', description: 'Doesn\'t wait to be asked. Suggests relevant services based on weather, time, guest profile, special occasions. Turns passive availability into active hospitality.' },
          { title: 'Enterprise Security', description: 'GDPR compliant from the ground up. End-to-end encryption. On-premise option. No guest data leaves your ecosystem. Full audit trails.' },
          { title: 'Human Escalation', description: 'Knows its limits. When a situation requires empathy, judgment, or authority, the AI escalates seamlessly to the right staff member with full context.' },
          { title: 'Learning System', description: 'Gets smarter with every interaction. Learns your hotel\'s patterns, popular requests, peak times, guest preferences. Continuously improves without manual updates.' }
        ]
      },
      liveExamples: {
        title: 'See AI Concierge in Action',
        subtitle: 'Real scenarios, real conversations — not scripted responses.',
        scenarioTitles: ['Family Dinner', 'Room Problem', 'Multilingual', 'Proactive Upselling'],
        scenarios: [
          { guest1: 'Hi, we need dinner tonight. Two adults, one child with a nut allergy. My wife is vegetarian. Something not too far.', ai1: 'I have three great options. La Terrazza, our in-house Italian restaurant, has an extensive vegetarian menu and is fully allergen-aware — they guarantee a nut-free kitchen. They also have a kids\' corner. Tables at 19:00 or 20:30. Alternatively, Chez Marcel (5 min walk) or Olivia\'s Garden (8 min, Mediterranean vegetarian). Shall I book?', guest2: 'La Terrazza at 19:00. High chair?', ai2: 'Done! Table for 3 at La Terrazza, 19:00, with high chair. Nut allergy and vegetarian preference flagged with the kitchen. Restaurant is on the 2nd floor — elevator by the lobby fountain. Want me to pre-order a kids\' meal to reduce waiting?' },
          { guest1: 'The room is freezing and I can\'t figure out the thermostat.', ai1: 'I\'ve raised the temperature to 23°C — you\'ll feel the change within 5 minutes. You can also just tell me "make it warmer" or "set it to 25" anytime. Want me to switch the lighting to a warmer tone too?', guest2: 'Yes please. Also the shower pressure is low.', ai2: 'Lighting adjusted. For the shower — I\'ve created a maintenance ticket. Our team will check within 20 minutes. I\'ll notify you when they\'re on the way and again once it\'s resolved.' },
          { note: 'The AI detects and responds in the guest\'s language automatically.', guest1: 'こんにちは。近くでおすすめのレストランはありますか？子供連れでも大丈夫なところがいいです。', ai1: 'こんにちは！お子様連れでしたら、3つおすすめがあります。「La Terrazza」は当ホテル内のイタリアンで、お子様用のコーナーがあります。「Olivia\'s Garden」は徒歩8分、テラス席がありお子様に人気です。「Chez Marcel」は徒歩5分のフレンチ料理で、落ち着いた雰囲気です。ご予約をお取りしましょうか？' },
          { guest1: null, ai1: 'Good afternoon, Mr. Thompson! I noticed tomorrow is a special date — happy anniversary! We have a sea-view suite available at a special rate, including complimentary champagne breakfast on the terrace. Would you like to see photos?', guest2: 'That sounds lovely! Tell me more.', ai2: 'Suite 801 has a panoramic sea view, private balcony, and separate living area. I can also arrange a couples\' spa treatment tomorrow at 16:00. Would you like me to set both up?', guest3: 'Yes, let\'s do it!', ai3: 'Wonderful! Suite upgrade and couples\' massage confirmed. I\'ll have your luggage moved within the hour, and a small anniversary surprise will be waiting. Happy anniversary!' }
        ]
      },
      integration: {
        title: 'It Plugs Into What You Already Have',
        subtitle: 'No system replacement needed. AI Concierge connects to your current stack.',
        categories: [
          { category: 'Property Management (PMS)', platforms: 'Oracle Opera, Mews, Cloudbeds, Protel, Clock PMS+', whatAiDoes: 'Check-in/out, room status, guest profiles, folio' },
          { category: 'CRM & Loyalty', platforms: 'Salesforce, Revinate, Cendyn', whatAiDoes: 'Guest history, preferences, loyalty, VIP recognition' },
          { category: 'Restaurant & Spa', platforms: 'OpenTable, TheFork, Book4Time, SpaSoft', whatAiDoes: 'Real-time booking, menus, availability, dietary flags' },
          { category: 'Smart Room / IoT', platforms: 'VDA, Crestron, Control4, Schneider Electric', whatAiDoes: 'Temperature, lighting, curtains, TV, DND' },
          { category: 'Guest Channels', platforms: 'Website Widget, Mobile SDK, Voice (SIP/VoIP)', whatAiDoes: 'Unified conversation across all touchpoints' }
        ]
      },
      guestJourney: {
        title: 'The Complete Guest Journey',
        phases: [
          { title: 'Before Arrival', points: 'Personalized welcome · Preference collection · Digital pre-check-in · Transfer booking · Destination tips' },
          { title: 'Arrival', points: 'Express check-in · Digital room key · Greeting in preferred language · Room orientation · Arrival-time offers' },
          { title: 'During Stay', points: 'Room service · Restaurant & spa booking · Smart room control · Local recommendations · Issue resolution · Proactive suggestions' },
          { title: 'Departure & Beyond', points: 'Express checkout · Real-time feedback · Personalized follow-up · Review management · Loyalty engagement' }
        ]
      },
      implementation: {
        title: 'From Zero to Live in 6 Weeks',
        phases: [
          { phase: 'Discovery & Configuration', duration: 'Week 1–2', description: 'System assessment, personality workshop, content ingestion, integration planning' },
          { phase: 'Integration & Training', duration: 'Week 3–4', description: 'System connections, AI fine-tuning, multilingual testing, staff training' },
          { phase: 'Soft Launch', duration: 'Week 5', description: 'Limited rollout, human-in-the-loop, performance benchmarking' },
          { phase: 'Full Deployment', duration: 'Week 6+', description: 'All channels live, weekly reviews, monthly analytics, continuous learning' }
        ]
      },
      security: {
        title: 'Security, Privacy & Ethics',
        subtitle: 'Guest data is sacred. Built in Europe, built for GDPR.',
        columns: [
          { title: 'Data Protection', points: 'GDPR compliant · End-to-end encryption (AES-256) · Automatic anonymization · Right to erasure · No third-party data sharing' },
          { title: 'Infrastructure', points: 'SOC 2 Type II ready · ISO 27001 aligned · Quarterly security audits · Role-based access control · Full audit trails' },
          { title: 'AI Ethics', points: 'Transparent AI disclosure · Seamless human escalation · No manipulative patterns · Bias testing · Full conversation logs' }
        ]
      },
      cta: {
        headline: 'Ready to See It in Action?',
        subtitle: 'Let\'s schedule a personalized demo with your hotel\'s actual scenarios.',
        button: 'Request a Demo',
        secondaryLink: 'Or contact us at contact@hitech-group.io'
      }
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      about: 'À propos',
      services: 'Services',
      aiConcierge: 'AI Concierge',
      approach: 'Approche',
      contact: 'Contact',
      contactUs: 'Contactez-nous'
    },
    hero: {
      headline: 'Conseil IT Intelligent',
      headlineLine2: '& Solutions Technologiques',
      subheadline: 'Structuré. Sécurisé. Enterprise-Grade.',
      description: 'HITECH GROUP est une société française de conseil et de technologies informatiques, filiale entièrement détenue de Global Services s.r.o., proposant des solutions numériques structurées et sécurisées pour les entreprises.',
      cta1: 'Découvrir nos services',
      cta2: 'Contactez-nous'
    },
    services: {
      title: 'Nos Services',
      subtitle: 'Des solutions de niveau entreprise adaptées à vos besoins',
      items: [
        {
          id: 'consulting',
          title: 'Conseil IT & Architecture',
          shortDesc: 'Accompagnement stratégique pour environnements IT complexes.',
          fullDesc: 'Accompagnement stratégique pour environnements IT complexes.',
          features: [
            'Conseil et accompagnement IT entreprise',
            'Feuilles de route de transformation digitale',
            'Architecture système et solutions',
            'Évaluation des technologies',
            'Développement de stratégie IT long terme'
          ]
        },
        {
          id: 'cloud',
          title: 'Cloud & Infrastructure',
          shortDesc: 'Infrastructure sécurisée et évolutive pour les entreprises modernes.',
          fullDesc: 'Infrastructure sécurisée et évolutive pour les entreprises modernes.',
          features: [
            'Conception et migration cloud',
            'Solutions d\'espace de travail virtuel',
            'Architecture cloud privé et hybride',
            'Optimisation d\'infrastructure',
            'Planification de reprise après sinistre'
          ]
        },
        {
          id: 'data',
          title: 'Data & Solutions IA',
          shortDesc: 'Systèmes intelligents pour des décisions basées sur les données.',
          fullDesc: 'Systèmes intelligents pour des décisions basées sur les données.',
          features: [
            'Architecture de plateforme de données',
            'Solutions de Business Intelligence',
            'Automatisation des processus',
            'Intégration IA et Machine Learning',
            'Systèmes d\'analyse prédictive'
          ]
        },
        {
          id: 'software',
          title: 'Logiciels & Plateformes Sur Mesure',
          shortDesc: 'Solutions personnalisées pour des besoins métier uniques.',
          fullDesc: 'Solutions personnalisées pour des besoins métier uniques.',
          features: [
            'Développement d\'applications entreprise',
            'Création de plateformes internes',
            'Personnalisation CRM et ERP',
            'Développement et intégration d\'API',
            'Modernisation des systèmes existants'
          ]
        }
      ]
    },
    trust: {
      title: 'Pourquoi Choisir HITECH GROUP',
      items: [
        {
          title: 'Standards de Sécurité Entreprise',
          description: 'Une approche sécurité d\'abord dans chaque solution que nous livrons.'
        },
        {
          title: 'Expertise de Groupe International',
          description: 'Soutenu par les capacités internationales de Global Services s.r.o.'
        },
        {
          title: 'Focus sur le Partenariat Long Terme',
          description: 'Construire des relations qui génèrent un succès durable.'
        }
      ]
    },
    cta: {
      title: 'Prêt à transformer votre infrastructure IT ?',
      button: 'Commencer une conversation'
    },
    about: {
      title: 'À propos',
      whoWeAre: {
        title: 'Qui Sommes-Nous',
        content: `HITECH GROUP est une société française de conseil et de technologies informatiques, filiale entièrement détenue de Global Services s.r.o., un groupe technologique international.

En tant que filiale entièrement détenue d'un groupe international, HITECH GROUP combine expertise locale française et capacités technologiques globales afin de proposer des solutions informatiques durables, sécurisées et adaptées aux entreprises.

Notre équipe réunit consultants, architectes et ingénieurs partageant un engagement commun pour la rigueur, l'excellence technique et la réussite de nos clients.`
      },
      values: {
        title: 'Nos Valeurs',
        items: [
          {
            title: 'Précision',
            description: 'Méthodologie structurée dans chaque engagement'
          },
          {
            title: 'Sécurité',
            description: 'Protection de niveau entreprise comme fondation'
          },
          {
            title: 'Partenariat',
            description: 'Relations long terme plutôt que transactions'
          }
        ]
      }
    },
    approach: {
      title: 'Notre Approche',
      intro: 'Nous croyons qu\'un conseil IT efficace nécessite plus que l\'expertise technique — il exige une pensée structurée, une exécution méthodique et un engagement sans faille envers la sécurité et la conformité. Notre approche est construite sur des standards entreprise et conçue pour un succès à long terme.',
      methodology: [
        {
          step: '01',
          title: 'Découvrir',
          description: 'Comprendre votre environnement et vos objectifs'
        },
        {
          step: '02',
          title: 'Concevoir',
          description: 'Architecturer des solutions alignées avec les standards entreprise'
        },
        {
          step: '03',
          title: 'Livrer',
          description: 'Implémenter avec précision et documentation'
        },
        {
          step: '04',
          title: 'Accompagner',
          description: 'Assurer performance et évolution à long terme'
        }
      ],
      principles: {
        title: 'Principes Clés',
        items: [
          'Mentalité sécurité d\'abord dans chaque décision',
          'Conformité aux standards européens et internationaux',
          'Architecture évolutive pour la croissance future',
          'Transfert de connaissances et documentation',
          'Communication transparente tout au long'
        ]
      }
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Discutons de comment nous pouvons soutenir vos objectifs IT.',
      form: {
        name: 'Nom complet',
        company: 'Nom de l\'entreprise',
        email: 'Adresse email',
        phone: 'Téléphone (optionnel)',
        subject: 'Sujet',
        subjectOptions: [
          { value: 'general', label: 'Demande générale' },
          { value: 'project', label: 'Discussion de projet' },
          { value: 'partnership', label: 'Partenariat' },
          { value: 'other', label: 'Autre' }
        ],
        message: 'Message',
        submit: 'Envoyer le message',
        sending: 'Envoi en cours...',
        successTitle: 'Message envoyé !',
        successMessage: 'Nous vous répondrons dans les 24 heures.',
        errorMessage: 'Échec de l\'envoi du message. Veuillez réessayer plus tard ou nous contacter directement.'
      },
      info: {
        title: 'Informations de Contact',
        address: '2323 Chemin de Saint-Bernard, 06220 Vallauris, France',
        email: 'contact@hitech-group.io',
        hours: 'Lundi – Vendredi : 9h00 – 18h00 (CET)'
      }
    },
    footer: {
      description: 'Société française de conseil et de technologies IT proposant des solutions de niveau entreprise.',
      quickLinks: 'Liens Rapides',
      contactInfo: 'Informations de Contact',
      legal: 'Mentions Légales',
      privacy: 'Politique de Confidentialité',
      terms: 'Conditions d\'Utilisation',
      legalNotice: 'Mentions Légales',
      corporateStatement: 'HITECH GROUP est une filiale entièrement détenue de Global Services s.r.o., un groupe technologique international.',
      copyright: '© 2025 HITECH GROUP. Tous droits réservés.'
    },
    legal: {
      privacyPolicy: {
        title: 'Politique de Confidentialité',
        lastUpdated: 'Dernière mise à jour : Janvier 2025',
        contactTitle: 'Contactez-nous',
        contactText: 'Si vous avez des questions concernant cette Politique de Confidentialité, veuillez nous contacter :',
        sections: [
          {
            title: '1. Introduction',
            content: [
              'HITECH GROUP (« nous », « notre » ou « nos ») s\'engage à protéger votre vie privée. Cette Politique de Confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations lorsque vous visitez notre site web ou utilisez nos services.',
              'HITECH GROUP est une société française de conseil et de technologies informatiques, filiale entièrement détenue de Global Services s.r.o., un groupe technologique international. En utilisant notre site web, vous acceptez les pratiques de données décrites dans cette politique.'
            ]
          },
          {
            title: '2. Informations que nous collectons',
            content: [
              'Nous pouvons collecter des informations que vous nous fournissez directement, notamment :',
              'Nous collectons également automatiquement certaines informations lorsque vous visitez notre site web, telles que votre adresse IP, le type de navigateur, les informations sur l\'appareil et les modèles d\'utilisation via des cookies et des technologies de suivi similaires.'
            ],
            list: [
              'Informations d\'identification personnelle (nom, adresse e-mail, numéro de téléphone)',
              'Informations sur l\'entreprise (nom de l\'entreprise, titre du poste)',
              'Données de communication (messages envoyés via nos formulaires de contact)',
              'Données techniques (adresse IP, type de navigateur, informations sur l\'appareil)',
              'Données d\'utilisation (pages visitées, temps passé sur les pages, modèles de clics)'
            ]
          },
          {
            title: '3. Comment nous utilisons vos informations',
            content: [
              'Nous utilisons les informations que nous collectons pour :',
              'Nous traitons vos données personnelles sur la base d\'intérêts commerciaux légitimes, de nécessité contractuelle, de conformité aux obligations légales ou de votre consentement.'
            ],
            list: [
              'Fournir, maintenir et améliorer nos services',
              'Répondre à vos demandes et fournir un support client',
              'Vous envoyer des mises à jour techniques, des newsletters et des communications marketing (avec votre consentement)',
              'Analyser l\'utilisation et les tendances du site web pour améliorer l\'expérience utilisateur',
              'Se conformer aux obligations légales et protéger nos droits légaux',
              'Prévenir la fraude et assurer la sécurité'
            ]
          },
          {
            title: '4. Partage et divulgation des données',
            content: [
              'Nous ne vendons pas vos informations personnelles. Nous pouvons partager vos informations avec :',
              'Nous exigeons que tous les tiers respectent la sécurité de vos données personnelles et les traitent conformément aux lois applicables sur la protection des données.'
            ],
            list: [
              'Notre société mère, Global Services s.r.o., pour les opérations commerciales et le support',
              'Les prestataires de services qui nous aident à exploiter notre site web et à mener nos activités (hébergement, analyses, services e-mail)',
              'Les autorités légales lorsque la loi l\'exige ou pour protéger nos droits',
              'Les partenaires commerciaux en relation avec les services que nous vous fournissons (avec votre consentement)'
            ]
          },
          {
            title: '5. Sécurité des données',
            content: [
              'Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre l\'accès non autorisé, l\'altération, la divulgation ou la destruction. Cependant, aucune méthode de transmission sur Internet ou de stockage électronique n\'est sécurisée à 100%.',
              'Nous utilisons des protocoles de sécurité standard de l\'industrie, un chiffrement le cas échéant, et des évaluations de sécurité régulières pour protéger vos informations.'
            ]
          },
          {
            title: '6. Vos droits',
            content: [
              'En vertu des lois applicables sur la protection des données (y compris le RGPD), vous avez le droit de :',
              'Pour exercer ces droits, veuillez nous contacter en utilisant les informations de contact fournies ci-dessous.'
            ],
            list: [
              'Accéder à vos données personnelles',
              'Rectifier les données inexactes ou incomplètes',
              'Demander la suppression de vos données personnelles',
              'Vous opposer au traitement de vos données personnelles',
              'Demander la limitation du traitement',
              'Portabilité des données',
              'Retirer votre consentement à tout moment',
              'Déposer une plainte auprès d\'une autorité de contrôle'
            ]
          },
          {
            title: '7. Cookies et technologies de suivi',
            content: [
              'Nous utilisons des cookies et des technologies de suivi similaires pour suivre l\'activité sur notre site web et stocker certaines informations. Vous pouvez demander à votre navigateur de refuser tous les cookies ou d\'indiquer quand un cookie est envoyé.',
              'Types de cookies que nous utilisons :',
              'Vous pouvez gérer vos préférences de cookies via les paramètres de votre navigateur.'
            ],
            list: [
              'Cookies essentiels : Nécessaires au bon fonctionnement du site web',
              'Cookies d\'analyse : Nous aident à comprendre comment les visiteurs interagissent avec notre site web',
              'Cookies fonctionnels : Mémorisent vos préférences et paramètres',
              'Cookies marketing : Utilisés pour diffuser des publicités pertinentes (avec votre consentement)'
            ]
          },
          {
            title: '8. Conservation des données',
            content: [
              'Nous conservons vos données personnelles uniquement aussi longtemps que nécessaire pour remplir les objectifs décrits dans cette Politique de Confidentialité, sauf si une période de conservation plus longue est requise ou autorisée par la loi.',
              'Lorsque nous n\'avons plus besoin de vos données personnelles, nous les supprimerons ou les anonymiserons de manière sécurisée.'
            ]
          },
          {
            title: '9. Transferts internationaux de données',
            content: [
              'Comme HITECH GROUP est une filiale entièrement détenue de Global Services s.r.o. (République tchèque), vos données peuvent être transférées et traitées dans des pays en dehors de l\'Espace économique européen (EEE).',
              'Nous veillons à ce que des garanties appropriées soient en place pour protéger vos données personnelles conformément aux lois applicables sur la protection des données, y compris les clauses contractuelles types approuvées par la Commission européenne.'
            ]
          },
          {
            title: '10. Modifications de cette Politique de Confidentialité',
            content: [
              'Nous pouvons mettre à jour cette Politique de Confidentialité de temps à autre. Nous vous informerons de tout changement en publiant la nouvelle Politique de Confidentialité sur cette page et en mettant à jour la date de "Dernière mise à jour".',
              'Il vous est conseillé de consulter périodiquement cette Politique de Confidentialité pour tout changement.'
            ]
          }
        ]
      },
      termsOfService: {
        title: 'Conditions d\'Utilisation',
        lastUpdated: 'Dernière mise à jour : Janvier 2025',
        contactTitle: 'Contactez-nous',
        contactText: 'Si vous avez des questions concernant ces Conditions d\'Utilisation, veuillez nous contacter :',
        sections: [
          {
            title: '1. Acceptation des conditions',
            content: [
              'En accédant et en utilisant le site web et les services de HITECH GROUP, vous acceptez et convenez d\'être lié par ces Conditions d\'Utilisation. Si vous n\'acceptez pas ces conditions, veuillez ne pas utiliser notre site web ou nos services.',
              'HITECH GROUP est une société française de conseil et de technologies informatiques, filiale entièrement détenue de Global Services s.r.o., un groupe technologique international.'
            ]
          },
          {
            title: '2. Description des services',
            content: [
              'HITECH GROUP fournit des services de conseil IT, des solutions technologiques et des services connexes, notamment mais sans s\'y limiter :',
              'Tous les services sont fournis sous réserve d\'accords de service séparés et de déclarations de travail qui régiront les conditions spécifiques, les livrables et la tarification pour chaque engagement.'
            ],
            list: [
              'Services de conseil IT et d\'architecture',
              'Conception et mise en œuvre d\'infrastructure cloud',
              'Solutions d\'analyse de données et d\'IA',
              'Développement de logiciels sur mesure',
              'Conseil en transformation digitale',
              'Services de conseil technologique'
            ]
          },
          {
            title: '3. Utilisation du site web',
            content: [
              'Vous acceptez d\'utiliser notre site web uniquement à des fins légales et conformément à ces Conditions d\'Utilisation. Vous acceptez de ne pas :',
              'Nous nous réservons le droit de résilier ou de suspendre l\'accès à notre site web immédiatement, sans préavis, pour tout comportement que nous estimons violer ces Conditions d\'Utilisation ou nuire à d\'autres utilisateurs, à nous ou à des tiers.'
            ],
            list: [
              'Violer toute loi ou réglementation applicable',
              'Porter atteinte aux droits d\'autrui',
              'Transmettre tout contenu nuisible, offensant ou illégal',
              'Tenter d\'obtenir un accès non autorisé à nos systèmes',
              'Interférer avec ou perturber le site web ou les serveurs',
              'Utiliser des systèmes automatisés pour accéder au site web sans autorisation',
              'Reproduire, dupliquer ou copier tout contenu sans autorisation'
            ]
          },
          {
            title: '4. Propriété intellectuelle',
            content: [
              'Tout le contenu de ce site web, y compris le texte, les graphiques, les logos, les images, les logiciels et autres matériaux, est la propriété de HITECH GROUP ou de ses concédants de licence et est protégé par les lois françaises et internationales sur le droit d\'auteur, les marques de commerce et autres droits de propriété intellectuelle.',
              'Vous ne pouvez pas reproduire, distribuer, modifier, créer des œuvres dérivées, afficher publiquement ou utiliser autrement tout contenu de ce site web sans notre consentement écrit préalable.'
            ]
          },
          {
            title: '5. Confidentialité et non-divulgation',
            content: [
              'Dans le cadre de la fourniture de services, HITECH GROUP peut avoir accès à des informations confidentielles appartenant aux clients. Nous maintenons des normes de confidentialité strictes et nous conformons à toutes les réglementations applicables sur la protection des données.',
              'Les clients peuvent également recevoir des informations confidentielles sur les méthodologies, processus et technologies propriétaires de HITECH GROUP, qui doivent être gardées confidentielles.'
            ]
          },
          {
            title: '6. Limitation de responsabilité',
            content: [
              'Dans la mesure maximale permise par la loi, HITECH GROUP et sa société mère Global Services s.r.o. ne seront pas responsables de tout dommage indirect, accessoire, spécial, consécutif ou punitif, ou de toute perte de profits ou de revenus, qu\'ils soient encourus directement ou indirectement, ou de toute perte de données, d\'utilisation, de bonne volonté ou d\'autres pertes intangibles.',
              'Notre responsabilité totale pour toute réclamation découlant de ou liée à votre utilisation de notre site web ou de nos services ne dépassera pas le montant que vous nous avez payé au cours des douze (12) mois précédant la réclamation.'
            ]
          },
          {
            title: '7. Avertissement concernant les garanties',
            content: [
              'Les informations sur ce site web sont fournies "telles quelles" sans garanties d\'aucune sorte, expresse ou implicite. Nous ne garantissons pas que le site web sera ininterrompu, sans erreur ou exempt de virus ou d\'autres composants nuisibles.',
              'Nous ne faisons aucune déclaration ni garantie concernant l\'exactitude, l\'exhaustivité ou l\'adéquation des informations à un usage particulier.'
            ]
          },
          {
            title: '8. Indemnisation',
            content: [
              'Vous acceptez d\'indemniser, de défendre et de dégager de toute responsabilité HITECH GROUP, Global Services s.r.o., et leurs dirigeants, directeurs, employés et agents respectifs contre toute réclamation, responsabilité, dommage, perte et dépense découlant de ou liée à votre utilisation de notre site web ou de nos services, violation de ces Conditions d\'Utilisation ou atteinte aux droits d\'un tiers.'
            ]
          },
          {
            title: '9. Droit applicable et juridiction',
            content: [
              'Ces Conditions d\'Utilisation seront régies et interprétées conformément aux lois de la France, sans égard à ses dispositions de conflit de lois.',
              'Tout litige découlant de ou lié à ces Conditions d\'Utilisation ou à nos services sera soumis à la juridiction exclusive des tribunaux français.'
            ]
          },
          {
            title: '10. Modifications des conditions',
            content: [
              'Nous nous réservons le droit de modifier ces Conditions d\'Utilisation à tout moment. Nous informerons les utilisateurs de tout changement matériel en publiant les conditions mises à jour sur cette page et en mettant à jour la date de "Dernière mise à jour".',
              'Votre utilisation continue de notre site web ou de nos services après de telles modifications constitue une acceptation des conditions mises à jour.'
            ]
          },
          {
            title: '11. Divisibilité',
            content: [
              'Si une disposition de ces Conditions d\'Utilisation est jugée inapplicable ou invalide, cette disposition sera limitée ou éliminée dans la mesure minimale nécessaire pour que ces Conditions d\'Utilisation restent par ailleurs en pleine vigueur et effet.'
            ]
          },
          {
            title: '12. Informations de contact',
            content: [
              'Pour toute question concernant ces Conditions d\'Utilisation, veuillez nous contacter en utilisant les informations fournies dans la section Contact de ce site web.'
            ]
          }
        ]
      },
      legalNotice: {
        title: 'Mentions Légales',
        lastUpdated: 'Dernière mise à jour : Janvier 2025',
        companyInfoTitle: 'Informations sur l\'entreprise',
        subsidiaryNote: 'HITECH GROUP est une filiale entièrement détenue de Global Services s.r.o.',
        sections: [
          {
            title: '1. Informations sur l\'entreprise',
            content: [
              'Ce site web est exploité par HITECH GROUP, une société française de conseil et de technologies informatiques.',
              'HITECH GROUP est une filiale entièrement détenue de Global Services s.r.o., un groupe technologique international basé en République tchèque.'
            ]
          },
          {
            title: '2. Directeur de publication',
            content: [
              'Le directeur de publication de ce site web est le représentant légal de HITECH GROUP.'
            ]
          },
          {
            title: '3. Hébergement',
            content: [
              'Ce site web est hébergé par des prestataires de services sélectionnés par HITECH GROUP. Pour des informations concernant l\'hébergement, veuillez nous contacter en utilisant les informations de contact fournies ci-dessous.'
            ]
          },
          {
            title: '4. Propriété intellectuelle',
            content: [
              'Tout le contenu de ce site web, y compris mais sans s\'y limiter le texte, les graphiques, les logos, les images, les clips audio, les téléchargements numériques et les logiciels, est la propriété de HITECH GROUP ou de ses fournisseurs de contenu et est protégé par les lois françaises et internationales sur le droit d\'auteur et les marques de commerce.',
              'Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le processus utilisé, est interdite sans autorisation écrite préalable de HITECH GROUP.'
            ]
          },
          {
            title: '5. Limitation de responsabilité',
            content: [
              'HITECH GROUP s\'efforce de fournir des informations précises et à jour sur ce site web. Cependant, nous ne pouvons garantir l\'exactitude, l\'exhaustivité ou l\'actualité de toutes les informations.',
              'HITECH GROUP ne sera pas responsable de tout dommage direct ou indirect résultant de l\'utilisation de ce site web ou de l\'impossibilité de l\'utiliser, y compris mais sans s\'y limiter la perte de données, la perte de profits ou l\'interruption des activités.',
              'Les informations sur ce site web sont fournies uniquement à des fins d\'information générale et ne constituent pas des conseils professionnels. Pour des conseils spécifiques concernant votre situation, veuillez consulter directement notre équipe.'
            ]
          },
          {
            title: '6. Liens externes',
            content: [
              'Ce site web peut contenir des liens vers des sites web externes. HITECH GROUP n\'est pas responsable du contenu, des pratiques de confidentialité ou de la sécurité des sites web externes.',
              'L\'inclusion de tout lien n\'implique pas l\'approbation par HITECH GROUP du site web lié ou de son contenu.'
            ]
          },
          {
            title: '7. Droit applicable',
            content: [
              'Ces Mentions Légales sont régies par le droit français. Tout litige découlant de l\'utilisation de ce site web sera soumis à la juridiction exclusive des tribunaux français.'
            ]
          },
          {
            title: '8. Protection des données',
            content: [
              'HITECH GROUP s\'engage à protéger vos données personnelles conformément aux lois applicables sur la protection des données, y compris le Règlement Général sur la Protection des Données (RGPD).',
              'Pour des informations détaillées sur la façon dont nous collectons, utilisons et protégeons vos données personnelles, veuillez consulter notre Politique de Confidentialité.'
            ]
          },
          {
            title: '9. Cookies',
            content: [
              'Ce site web utilise des cookies pour améliorer l\'expérience utilisateur et analyser le trafic du site web. En continuant à utiliser ce site web, vous acceptez notre utilisation des cookies.',
              'Pour plus d\'informations sur notre utilisation des cookies, veuillez consulter notre Politique de Confidentialité.'
            ]
          }
        ]
      }
    },
    aiConcierge: {
      meta: { title: 'AI Concierge Service | HITECH GROUP', description: 'Plateforme de conciergerie IA pour hôtels. Intégrée PMS, CRM, IoT. 30+ langues. Service client personnalisé 24h/24.' },
      hero: {
        badge: 'Hôtellerie propulsée par l\'IA',
        headline: 'AI Concierge Service',
        subheadline: 'Votre meilleur collaborateur ne dort jamais',
        description: 'Une plateforme de conciergerie alimentée par l\'IA qui s\'intègre à l\'écosystème de votre hôtel, comprend vos clients et offre un service personnalisé à chaque interaction — 24h/24, dans toutes les langues, sans recruter.',
        ctaDemo: 'Demander une démo →',
        ctaLearn: 'En savoir plus',
        stats: [
          { label: 'Disponibilité', value: '24/7' },
          { label: 'Langues', value: '30+' },
          { label: 'Temps de réponse', value: '<3s' },
          { label: 'Résolution des demandes', value: '85%' }
        ]
      },
      problem: {
        title: 'La réalité des opérations hôtelières aujourd\'hui',
        subtitle: 'Chaque directeur d\'hôtel connaît ces situations. Elles se produisent quotidiennement.',
        items: [
          { problemTitle: 'Le problème de 2h du matin', problem: 'Il est 2h17 du matin. Un couple japonais arrive après un vol retardé. Ils ne parlent ni anglais ni français. Le réceptionniste de nuit est seul, occupé par une plainte pour bruit. Le couple a besoin d\'indications, veut manger, et leur chambre est trop froide. Ils attendent 12 minutes avant d\'être aidés. Le matin, un avis négatif est déjà publié.', solution: 'Le client ouvre l\'application de l\'hôtel. L\'IA détecte automatiquement sa langue et l\'accueille en japonais. Elle le guide vers sa chambre avec un plan visuel, commande un repas tardif et ajuste la température — le tout avant qu\'il n\'atteigne sa porte. Le réceptionniste n\'a jamais eu à quitter sa tâche en cours.' },
          { problemTitle: 'Le piège de la répétition', problem: 'Votre réception répond aux mêmes 15-20 questions des centaines de fois par semaine : mot de passe Wi-Fi, horaires du petit-déjeuner, emplacement de la salle de sport, late checkout, directions pour l\'aéroport. Chaque réponse prend 1 à 3 minutes. Vos meilleurs professionnels passent l\'essentiel de leur temps comme terminal FAQ au lieu de créer des expériences mémorables.', solution: 'L\'AI Concierge répond instantanément à chaque question répétitive avec des réponses contextuelles. Quand un client demande le petit-déjeuner à 10h45, il ne dit pas simplement « 7h-11h » — il répond : « Le petit-déjeuner est encore servi pendant 15 minutes. Je peux aussi réserver une table pour le déjeuner à 13h. » Votre personnel est libéré pour se consacrer à l\'hospitalité authentique.' },
          { problemTitle: 'La barrière linguistique', problem: 'Une famille allemande demande des activités pour enfants. Le réceptionniste tente d\'expliquer en anglais basique, mais les nuances sont perdues. Ils ratent l\'excursion en bateau idéale. Un couple brésilien veut un soin spa spécifique mais ne peut pas communiquer les détails. Ils abandonnent et vont chez un concurrent. Chaque malentendu est une connexion manquée — et un revenu perdu.', solution: 'L\'AI Concierge communique nativement dans plus de 30 langues — pas simplement en traduisant des mots, mais en comprenant le contexte culturel. Il recommande l\'excursion en bateau à la famille allemande car il sait qu\'ils ont des enfants. Il explique chaque option spa au couple brésilien en portugais courant et réserve exactement le soin souhaité. Aucun malentendu. Aucun client perdu.' },
          { problemTitle: 'Le revenu invisible', problem: 'Votre hôtel a un spa magnifique, un excellent restaurant et des partenariats avec des tours opérateurs. Mais la plupart des clients n\'en entendent jamais parler — ou trop tard. « Je ne savais pas que vous aviez un rooftop bar ! » Le personnel est trop occupé pour des suggestions proactives. Les brochures restent non lues.', solution: 'L\'AI Concierge suggère proactivement des services pertinents selon le contexte et le moment. Par un après-midi pluvieux, il recommande le spa. Avant le dîner, il met en avant le menu spécial du soir. Quand un client mentionne un anniversaire, il propose un surclassement ou un package champagne. L\'IA n\'attends pas qu\'on lui demande — elle aide les clients à découvrir tout ce que votre hôtel offre.' },
          { problemTitle: 'Le feedback qui arrive trop tard', problem: 'Un client a eu une mauvaise expérience de propreté le premier jour. Il n\'a rien dit. A supporté pendant trois jours. A refusé le questionnaire de départ. Deux jours plus tard, un avis une étoile sur TripAdvisor. Vous n\'avez jamais eu la chance de corriger. Le problème n\'était pas la propreté — c\'est que le client n\'avait aucun moyen simple de le signaler.', solution: 'L\'AI Concierge crée un canal à faible friction pour le feedback en temps réel. Il prend des nouvelles proactivement : « Comment se passe votre séjour ? » Quand le client mentionne le problème, l\'IA crée un ticket ménage, envoie une équipe et fait un suivi dans l\'heure. L\'avis une étoile n\'est jamais écrit. Au contraire, le client part impressionné.' },
          { problemTitle: 'Le problème d\'incohérence', problem: 'Votre meilleure concierge, Maria, connaît chaque client par son nom, se souvient de ses préférences, rend chaque interaction personnelle. Mais Maria travaille du lundi au vendredi, de 8h à 16h. Les week-ends, jours fériés, nuits — la qualité de service baisse. Les nouveaux ne connaissent pas les habitués. Les saisonniers n\'ont pas appris les recommandations locales. La qualité dépend de qui est de service.', solution: 'L\'AI Concierge offre une personnalisation de niveau Maria, 24h/24, 365 jours par an. Il se souvient de chaque client, chaque préférence, chaque interaction passée — pour toujours. Quand M. Chen revient pour la troisième fois, l\'IA l\'accueille par son nom, propose sa chambre préférée en étage élevé et suggère le restaurant qu\'il a adoré lors de sa dernière visite. La constance ne dépend plus du personnel en poste.' }
        ]
      },
      beforeAfter: {
        title: 'Avant vs. Après : Une journée dans votre hôtel',
        rows: [
          { situation: 'Client arrive à 2h', without: 'Attend le seul réceptionniste de nuit. Communication limitée à l\'anglais basique.', with: 'Accueil instantané dans sa langue maternelle. Guide de chambre, repas, température — tout géré avant d\'atteindre la chambre.' },
          { situation: '100 clients demandent le Wi-Fi', without: 'Le personnel répond à la même question 100 fois. ~3h de temps personnel par jour.', with: 'L\'IA répond instantanément à chaque fois. Le personnel est libéré pour des interactions significatives.' },
          { situation: 'Client a une plainte', without: 'Le client hésite à aller à la réception. La frustration monte. Avis négatif après le départ.', with: 'Le client mentionne le problème via l\'app. Ticket créé et résolu en 30 min. Le client se sent écouté.' },
          { situation: 'Recommandation dîner', without: 'Dépend de quel employé est interrogé. Le nouveau donne une réponse générique.', with: 'L\'IA recommande selon les préférences, régimes, taille du groupe, disponibilité en temps réel. Réserve instantanément.' },
          { situation: 'VIP de retour', without: 'Le nouveau réceptionniste ne le reconnaît pas. Le client doit répéter toutes ses préférences.', with: 'L\'IA accueille par son nom, rappelle les préférences, propose proactivement la chambre et le restaurant favoris.' },
          { situation: 'L\'hôtel a un super spa', without: 'Brochure en chambre non lue. Le client part sans savoir que le spa existait.', with: 'L\'IA suggère le spa un après-midi pluvieux quand le client n\'a pas de plans. Réservé en 30 secondes.' },
          { situation: 'Haute saison', without: 'Personnel débordé. Temps de réponse augmentent. Qualité de service baisse.', with: 'L\'IA gère un nombre illimité de conversations simultanées. Le personnel se concentre sur les situations complexes.' }
        ]
      },
      howItWorks: {
        title: 'Comment fonctionne l\'AI Concierge',
        subtitle: 'Pas un chatbot. Une plateforme d\'hospitalité intelligente qui comprend, agit et apprend.',
        cards: [
          { title: 'IA contextuelle', description: 'Comprend l\'intention, pas seulement les mots-clés. Gère des demandes complexes en plusieurs étapes, mémorise l\'historique. Quand un client demande « quelque chose pour les enfants », elle connaît leur âge grâce à la réservation.' },
          { title: 'Intégration profonde', description: 'Connecté au PMS, CRM, réservation restaurant/spa, contrôle IoT des chambres. L\'IA ne répond pas seulement — elle réserve des tables, ajuste les thermostats, crée des tickets de maintenance, traite les check-ins.' },
          { title: 'Vrai multilingue', description: 'Conversation de qualité native dans plus de 30 langues avec conscience culturelle. Pas de traduction automatique — l\'IA comprend les nuances, expressions locales et niveaux de formalité appropriés.' },
          { title: 'Voix & Texte', description: 'Assistant vocal en chambre pour une interaction mains-libres, plus canaux texte via app et widget web. Les clients choisissent comment communiquer. Le contexte suit à travers les canaux.' },
          { title: 'Service proactif', description: 'N\'attend pas qu\'on lui demande. Suggère des services pertinents selon la météo, l\'heure, le profil client, les occasions spéciales. Transforme la disponibilité passive en hospitalité active.' },
          { title: 'Sécurité entreprise', description: 'Conforme RGPD dès la conception. Chiffrement de bout en bout. Option on-premise. Aucune donnée client ne quitte votre écosystème. Traçabilité complète.' },
          { title: 'Escalade humaine', description: 'Connaît ses limites. Quand une situation nécessite empathie, jugement ou autorité, l\'IA transfère de manière fluide au bon collaborateur avec tout le contexte.' },
          { title: 'Système apprenant', description: 'Devient plus intelligent à chaque interaction. Apprend les habitudes de votre hôtel, demandes populaires, heures de pointe, préférences des clients. S\'améliore continuellement sans mise à jour manuelle.' }
        ]
      },
      liveExamples: {
        title: 'L\'AI Concierge en action',
        subtitle: 'Des scénarios réels, des conversations réelles — pas de réponses scriptées.',
        scenarioTitles: ['Dîner en famille', 'Problème de chambre', 'Multilingue', 'Suggestion proactive'],
        scenarios: [
          { guest1: 'Bonjour, on cherche un dîner ce soir. Deux adultes, un enfant allergique aux noix. Ma femme est végétarienne. Pas trop loin si possible.', ai1: 'J\'ai trois excellentes options. La Terrazza, notre restaurant italien, a un large menu végétarien et garantit une cuisine sans noix. Il y a aussi un coin enfants. Tables à 19h ou 20h30. Sinon, Chez Marcel (5 min à pied) ou Olivia\'s Garden (8 min, méditerranéen végétarien). Je réserve ?', guest2: 'La Terrazza à 19h. Chaise haute ?', ai2: 'C\'est fait ! Table pour 3 à La Terrazza, 19h, avec chaise haute. Allergie aux noix et préférence végétarienne signalées à la cuisine. Le restaurant est au 2e étage — ascenseur près de la fontaine du lobby. Voulez-vous que je précommande un menu enfant pour réduire l\'attente ?' },
          { guest1: 'La chambre est glaciale et je ne comprends pas le thermostat.', ai1: 'J\'ai augmenté la température à 23°C — vous sentirez le changement dans environ 5 minutes. Vous pouvez aussi simplement me dire « plus chaud » ou « mets à 25 » à tout moment. Vous voulez que je passe l\'éclairage en ton plus chaud aussi ?', guest2: 'Oui s\'il vous plaît. Et la pression de la douche est faible.', ai2: 'Éclairage ajusté. Pour la douche — j\'ai créé un ticket de maintenance. Notre équipe viendra vérifier dans les 20 minutes. Je vous préviens quand ils arrivent et quand c\'est résolu.' },
          { note: 'L\'IA détecte et répond dans la langue du client automatiquement.', guest1: 'こんにちは。近くでおすすめのレストランはありますか？子供連れでも大丈夫なところがいいです。', ai1: 'こんにちは！お子様連れでしたら、3つおすすめがあります。「La Terrazza」は当ホテル内のイタリアンで、お子様用のコーナーがあります。「Olivia\'s Garden」は徒歩8分、テラス席がありお子様に人気です。「Chez Marcel」は徒歩5分のフレンチ料理で、落ち着いた雰囲気です。ご予約をお取りしましょうか？' },
          { guest1: null, ai1: 'Bonjour M. Thompson ! J\'ai remarqué que demain est une date spéciale — joyeux anniversaire de mariage ! Nous avons une suite vue mer disponible à un tarif spécial, avec petit-déjeuner champagne offert sur la terrasse. Souhaitez-vous voir des photos ?', guest2: 'Ça a l\'air merveilleux ! Dites-moi en plus.', ai2: 'La Suite 801 offre une vue mer panoramique, un balcon privé et un salon séparé. Je peux aussi organiser un soin spa en duo demain à 16h. Voulez-vous que j\'organise les deux ?', guest3: 'Oui, allons-y !', ai3: 'Parfait ! Surclassement en suite et massage en duo confirmés. Vos bagages seront transférés dans l\'heure, et une petite surprise d\'anniversaire vous attendra. Joyeux anniversaire !' }
        ]
      },
      integration: {
        title: 'Il s\'intègre à ce que vous avez déjà',
        subtitle: 'Aucun remplacement de système. L\'AI Concierge se connecte à votre stack actuel.',
        categories: [
          { category: 'Gestion hôtelière (PMS)', platforms: 'Oracle Opera, Mews, Cloudbeds, Protel, Clock PMS+', whatAiDoes: 'Check-in/out, statut chambre, profils clients, facturation' },
          { category: 'CRM & Fidélité', platforms: 'Salesforce, Revinate, Cendyn', whatAiDoes: 'Historique client, préférences, fidélité, reconnaissance VIP' },
          { category: 'Restaurant & Spa', platforms: 'OpenTable, TheFork, Book4Time, SpaSoft', whatAiDoes: 'Réservation temps réel, menus, disponibilité, allergies' },
          { category: 'Chambre connectée / IoT', platforms: 'VDA, Crestron, Control4, Schneider Electric', whatAiDoes: 'Température, éclairage, rideaux, TV, Ne pas déranger' },
          { category: 'Canaux clients', platforms: 'Website Widget, Mobile SDK, Voice (SIP/VoIP)', whatAiDoes: 'Conversation unifiée sur tous les points de contact' }
        ]
      },
      guestJourney: {
        title: 'Le parcours client complet',
        phases: [
          { title: 'Avant l\'arrivée', points: 'Accueil personnalisé · Collecte des préférences · Pré-check-in digital · Réservation transfert · Conseils destination' },
          { title: 'Arrivée', points: 'Check-in express · Clé digitale · Accueil dans la langue préférée · Orientation chambre · Offres selon l\'heure d\'arrivée' },
          { title: 'Pendant le séjour', points: 'Room service · Réservation restaurant & spa · Contrôle chambre · Recommandations locales · Résolution de problèmes · Suggestions proactives' },
          { title: 'Départ & après', points: 'Checkout express · Feedback en temps réel · Suivi personnalisé · Gestion des avis · Engagement fidélité' }
        ]
      },
      implementation: {
        title: 'De zéro au lancement en 6 semaines',
        phases: [
          { phase: 'Découverte & Configuration', duration: 'Semaine 1–2', description: 'Évaluation systèmes, atelier personnalité, ingestion contenu, planification intégrations' },
          { phase: 'Intégration & Formation', duration: 'Semaine 3–4', description: 'Connexions systèmes, fine-tuning IA, tests multilingues, formation équipe' },
          { phase: 'Lancement pilote', duration: 'Semaine 5', description: 'Déploiement limité, supervision humaine, benchmarking performance' },
          { phase: 'Déploiement complet', duration: 'Semaine 6+', description: 'Tous canaux actifs, revues hebdomadaires, analytics mensuels, apprentissage continu' }
        ]
      },
      security: {
        title: 'Sécurité, confidentialité & éthique',
        subtitle: 'Les données clients sont sacrées. Conçu en Europe, conçu pour le RGPD.',
        columns: [
          { title: 'Protection des données', points: 'Conforme RGPD · Chiffrement bout en bout (AES-256) · Anonymisation automatique · Droit à l\'effacement · Aucun partage de données tiers' },
          { title: 'Infrastructure', points: 'SOC 2 Type II ready · Aligné ISO 27001 · Audits sécurité trimestriels · Contrôle d\'accès par rôle · Traçabilité complète' },
          { title: 'Éthique IA', points: 'Transparence IA · Escalade humaine fluide · Aucune manipulation · Tests de biais · Logs de conversation complets' }
        ]
      },
      cta: {
        headline: 'Prêt à le voir en action ?',
        subtitle: 'Planifions une démo personnalisée avec les scénarios réels de votre hôtel.',
        button: 'Demander une démo',
        secondaryLink: 'Ou contactez-nous à contact@hitech-group.io'
      }
    }
  }
};

export const logos = {
  dark: 'https://customer-assets.emergentagent.com/job_32decaf3-64e3-4f7c-aef5-7951ffc0b89c/artifacts/a6lx4ryu_Logo-B.png',
  light: 'https://customer-assets.emergentagent.com/job_32decaf3-64e3-4f7c-aef5-7951ffc0b89c/artifacts/xda0oe6w_Logo-w.png'
};
